const component = "weekly-program";

export const weeklyProgram = {
  component,
  businessDaysLabel: `${component}/business-days-label`,
  weekendLabel: `${component}/weekend-label`,
  hourScale: `${component}/hour-scale`,
  hour: `${component}/hour`,
  schedule: `${component}/schedule`,
  day: `${component}/day`,
  dailyProgramOptions: {
    button: `${component}/daily-program-options/button`,
    icon: `${component}/daily-program-options/icon`,
  },
  contextMenu: `${component}/context-menu`,
};
